import { render, staticRenderFns } from "./InStock.vue?vue&type=template&id=9634b8c4&"
import script from "./InStock.vue?vue&type=script&lang=js&"
export * from "./InStock.vue?vue&type=script&lang=js&"
import style0 from "./InStock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports